export default __webpack_public_path__ + "static/media/python.ec327b95.png";